import React from "react";
import RangeSelector from "./RangeSelector";

interface BedsRangeSelectorProps {
  value?: [number | undefined, number | undefined];
  onChange?: (value: [number | undefined, number | undefined]) => void;
  showAny?: boolean;
}

const BedsRangeSelector = ({ 
  value, 
  onChange, 
  showAny = true 
}: BedsRangeSelectorProps) => {
  return (
    <RangeSelector
      options={["1", "2", "3", "4", "5+"]}
      value={value}
      onChange={onChange}
      showAny={showAny}
    />
  );
};

export default BedsRangeSelector;